'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unwrapWithUrl = exports.wrapWithUrl = exports.gradientRegex = exports.urlWrappedRegex = undefined;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _sizes;
var _ResponsiveModes = require('../constants/ResponsiveModes');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var sizes = (_sizes = {}, _defineProperty(_sizes, _ResponsiveModes.MOBILE, 'medium'), _defineProperty(_sizes, _ResponsiveModes.TABLET, 'large'), _defineProperty(_sizes, _ResponsiveModes.DESKTOP, 'large'), _sizes);
var urlWrappedRegex = exports.urlWrappedRegex = /(?:^url\(.+\)$)/i;
var gradientRegex = exports.gradientRegex = /^linear-gradient\([^\)]+\)/i;
var wrapWithUrl = exports.wrapWithUrl = function wrapWithUrl(source) {
  var responsiveMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ResponsiveModes.MOBILE;
  var url = (typeof source === 'undefined' ? 'undefined' : _typeof(source)) === 'object' ? source[sizes[responsiveMode]] : source;
  return !urlWrappedRegex.test(url) && !gradientRegex.test(url) ? 'url(' + url + ')' : url;
};
var unwrapWithUrl = exports.unwrapWithUrl = function unwrapWithUrl(url) {
  return typeof url === 'string' && urlWrappedRegex.test(url) ? url.substring(4, url.length - 1) : url;
};